import React from "react";
import ReactDOM from "react-dom/client";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
// import { JWTAuthProvider } from "contexts/JWTAuth";
import "nprogress/nprogress.css";
import "pure-react-carousel/dist/react-carousel.es.css";
// import "react-image-lightbox/style.css";
import "react-quill/dist/quill.snow.css";
import { BrowserRouter } from "react-router-dom";
//import "simplebar/dist/simplebar.min.css";
import App from "./App";
import SettingsProvider from "contexts/settingsContext";
//import reportWebVitals from "./reportWebVitals";
//import "./__fakeData__";

import { store } from './app/store'
import { Provider } from 'react-redux'
import ConfigureAmplify from 'amplify/amplifyConfigure'
import { Authenticator } from '@aws-amplify/ui-react';


ConfigureAmplify()

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Authenticator.Provider >
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <SettingsProvider>
          {/* <JWTAuthProvider> */}
            <BrowserRouter>
              <App />
            </BrowserRouter>
          {/* </JWTAuthProvider> */}
        </SettingsProvider>
      </LocalizationProvider>
      </Authenticator.Provider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();
